import axios, { AxiosResponse } from "axios";
import { CartItem, CartItemForDB } from "../@types/cartItems";

const API_URL = "https://sodastreamapi.azurewebsites.net/cart";

class CartService {
  async getProductByItemCodes(
    order_reference: string
  ): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.get(
        `${API_URL}/products/${order_reference}`
      );

      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = "Error fetching product by SKU";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching product by SKU:", error.message);
      return { data: null, error: error.message };
    }
  }

  async getItemByOrderReference(
    order_reference: string
  ): Promise<{ data: CartItem | null; error: string | null }> {
    try {
      const response: AxiosResponse<CartItem> = await axios.get(
        `${API_URL}/cart/items/${order_reference}`
      );
      if (response.status >= 200 && response.status < 300) {
        const items: CartItem = response.data;

        return { data: items, error: null };
      } else {
        const error = "Error fetching item by order reference";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching item by order reference:", error);
      return { data: null, error };
    }
  }

  async removeFromCart(
    order_reference: string
  ): Promise<{ data?: string; error?: string }> {
    try {
      const response: AxiosResponse<{ message: string }> = await axios.delete(
        `${API_URL}/remove/${order_reference}`
      );

      if (response.status >= 200 && response.status < 300) {
        return { data: response.data.message };
      } else {
        const error = "Error removing items from cart";
        console.error(error);
        return { error };
      }
    } catch (error: any) {
      console.error("Error removing items from cart:", error.message);
      return { error: error.message };
    }
  }

  async addToCart(
    cartItem: CartItemForDB
  ): Promise<{ data: CartItemForDB | null; error: string | null }> {
    try {
      const response: AxiosResponse<CartItemForDB> = await axios.post(
        `${API_URL}/add`,
        cartItem
      );
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = "Error adding item to cart";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error adding item to cart:", error.message);
      return { data: null, error: error.message };
    }
  }

  async updateCartItem(
    cartItem: CartItemForDB
  ): Promise<{ data: CartItemForDB | null; error: string | null }> {
    try {
      const response: AxiosResponse<{
        message: string;
        cartItem: CartItemForDB;
      }> = await axios.put(`${API_URL}/update`, cartItem);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data.cartItem, error: null };
      } else {
        const error = "Error updating cart item";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error updating cart item:", error.message);
      return { data: null, error: error.message };
    }
  }

  async updateUserIdByOrderReference(
    order_reference: string,
    user_id: number
  ): Promise<{ data: CartItem[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<{
        message: string;
        updatedItems: CartItem[];
      }> = await axios.put(`${API_URL}/update-user-id`, {
        order_reference,
        user_id,
      });
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data.updatedItems, error: null };
      } else {
        const error = "Error updating user ID by order reference";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error(
        "Error updating user ID by order reference:",
        error.message
      );
      return { data: null, error: error.message };
    }
  }
}

const cartServiceInstance = new CartService();
export default cartServiceInstance;
